// 定义默认数据并导出
const defaultState = {
    currentData:{s:'111'}
}
//传实际参数了就用实际参数，没传就用defaultState
export default (state = defaultState,action)=>{
    return state
}